import { computed } from 'vue'
import { useOnline } from '@vueuse/core'
import PotaParkService from '@/services/PotaParkService'

export function usePotaParksSync() {
  const online = useOnline()
  const isOffline = computed(() => !online.value)

  return {
    online,
    isOffline,
    checkForUpdates: async () => {
      if (!online.value) {
        throw new Error('Cannot check for updates while offline')
      }
      return PotaParkService.checkForUpdates()
    },
    forceSync: async () => {
      if (!online.value) {
        throw new Error('Cannot sync while offline')
      }
      return PotaParkService.forceSync()
    }
  }
}